import Foundation from "@microsoft/fast-components-foundation-react";
import { AutoSuggestContext, ListboxItem as BaseListboxItem, } from "@microsoft/fast-components-react-base";
import { classNames, startsWith } from "@microsoft/fast-web-utilities";
import { isNil } from "lodash-es";
import React from "react";
import { DisplayNamePrefix } from "../utilities";
class AutoSuggestOption extends Foundation {
    constructor() {
        super(...arguments);
        this.handledProps = {
            value: void 0,
            id: void 0,
            displayFormatter: void 0,
            formatDisplayString: void 0,
            managedClasses: void 0,
        };
        /**
         * Calls the right function to format the display string
         */
        this.formatDisplayString = () => {
            const displayString = this.props.displayString !== undefined
                ? this.props.displayString
                : this.props.value;
            if (!this.props.formatDisplayString) {
                return displayString;
            }
            return typeof this.props.displayFormatter === "function"
                ? this.props.displayFormatter(displayString, this.context.currentValue)
                : this.defaultDisplayFormatter(displayString, this.context.currentValue);
        };
        /**
         * Default display string formatter function
         */
        this.defaultDisplayFormatter = (displayString, searchString) => {
            if (!isNil(displayString) &&
                !isNil(searchString) &&
                startsWith(displayString.toLowerCase(), searchString.toLowerCase())) {
                return (React.createElement("span", null,
                    React.createElement("b", null, displayString.substring(0, searchString.length)),
                    displayString.substring(searchString.length, displayString.length)));
            }
            return displayString;
        };
    }
    render() {
        const { autoSuggestOption, autoSuggestOption__selected, autoSuggestOption__disabled, autoSuggestOption_contentRegion, } = this.props.managedClasses;
        return (React.createElement(BaseListboxItem, Object.assign({}, this.unhandledProps(), { id: this.props.id, value: this.props.value, managedClasses: {
                listboxItem: classNames(autoSuggestOption),
                listboxItem__disabled: classNames(autoSuggestOption__disabled),
                listboxItem__selected: classNames(autoSuggestOption__selected),
            } }),
            React.createElement("span", { className: classNames(autoSuggestOption_contentRegion) },
                this.formatDisplayString(),
                this.props.children)));
    }
}
AutoSuggestOption.displayName = `${DisplayNamePrefix}AutoSuggestOption`;
AutoSuggestOption.contextType = AutoSuggestContext;
AutoSuggestOption.defaultProps = {
    formatDisplayString: true,
    managedClasses: {},
};
AutoSuggestOption.contextType = AutoSuggestContext;
export default AutoSuggestOption;
